import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LangPickerComponent} from './lang-picker.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MatSelectModule} from '@angular/material';
import {SupportLang} from './support-lang/support-lang';

@NgModule({
  imports: [
    CommonModule,
    MatSelectModule,
    TranslateModule
  ],
  exports: [LangPickerComponent],
  declarations: [LangPickerComponent],
  providers: [TranslateService, SupportLang],
})
export class LangPickerModule { }



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/shared/lang-picker/lang-picker.module.ts